export const handleApiError = (error: any): void => {
  console.error('Handle Api Error', error)
  const errorMessage = error.response?.data?.message;
  const errorType = error.response?.data?.type;
  const isDashboard = window.location.pathname.includes('/dashboard');
  const message = Array.isArray(errorMessage) ? errorMessage[0] : errorMessage;

  const clearAuthStorage = () => {
    localStorage.clear();
    sessionStorage.clear();
  };

  if (error.response?.status === 401) {
    if (!isDashboard && message) {
      throw new Error(message);
    }

    if (errorType === 'GEN-0007') {
      clearAuthStorage();
      setTimeout(() => {
        window.location.replace("/login");
      }, 2500);
      if (message) {
        throw new Error(message);
      }
      return;
    }

    if (isDashboard) {
      clearAuthStorage();
      window.location.replace("/login");
      return;
    }

    throw new Error(message || 'Incorrect credentials or account not verified');
  }

  if (Array.isArray(errorMessage) && errorMessage.length) {
    throw new Error(errorMessage[0]);
  }
  if (errorMessage) {
    throw new Error(errorMessage);
  }
  if (error.message) {
    throw new Error(error.message);
  }
  throw new Error('Something went wrong. Please try again.');
};
